export const videoPlayer = {
	init: function(videoPlayerContainer) {
		if (!videoPlayerContainer) return
		this.videoPlayer = videoPlayerContainer;
		this.image = videoPlayerContainer.querySelector('.video-player__image');
		this.durationLabel = videoPlayerContainer.querySelector('.video-player__time');
		this.topLayer = videoPlayerContainer.querySelector('.video-player__top-layer');
		this.videoIframe = videoPlayerContainer.querySelector('.video-player__iframe');
		this.youtubeIframeReady();
		this.youtubeImagePlaceholder(this.videoIframe.src);
	},
	youtubeIframeReady: function() {
		const tag = document.createElement('script');
		tag.src = "https://www.youtube.com/iframe_api";
		const firstScriptTag = document.getElementsByTagName('script')[0];
		firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

		let player;
		window.onYouTubeIframeAPIReady = function(e) {
			player = new YT.Player('player', {
				events: {
					'onReady': videoPlayer.youtubePlayerReady
				}
			});
		}
	},
	youtubePlayerReady: function(event) {
		videoPlayer.calculateDurationTime(event);
		videoPlayer.videoPlayer.addEventListener('click', function(e) {
			event.target.playVideo();
			videoPlayer.topLayer.style.display = 'none';
		});
	},
	calculateDurationTime: function(event) {
		const time = event.target.getDuration(),
		 	  date = new Date(null);
		date.setSeconds(time);
		let result = date.toISOString().substr(11, 8);
		if (result.indexOf('00') === 0) {
			result = result.substring(3);
		}
		videoPlayer.durationLabel.innerHTML = result;
	},
	youtubeImagePlaceholder: function(url) {
		if (!this.image) return;
	    const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/,
	     	  match = url.match(regExp),
	     	  youtubeID = (match && match[7].length === 11) ? match[7] : false,
		 	  imgUrl = 'https://i.ytimg.com/vi/' + youtubeID + '/maxresdefault.jpg';
		this.image.src = imgUrl;
	}
}
